export default [
  {
    displayName: "Vertragsadministration",
    title: "Home",
    href: null,
    id: "mainMenuItemContractAdministration",
    subMenu: [
      {
        displayName: "Vertragssuche",
        title: "Vertragssuche",
        href: "/home",
        id: "subMenuItemContractSearch",
        requiresLogin: true,
      },
      {
        displayName: "TOP GAV",
        title: "TOP GAV",
        href: "/topgav",
        id: "subMenuItemManageTopGav",
        requiresLogin: true,
      },
      {
        displayName: "Vertrags-Validierungsregeln verwalten",
        title: "Vertrags-Validierungsregeln verwalten",
        href: "/validierungsRegeln",
        id: "subMenuItemValidationRules",
        requiresLogin: true,
      },
      {
        displayName: "Gesetzlicher Mindestlohn",
        title: "Gesetzlicher Mindestlohn",
        href: "/gesetzlicherMindestlohnUebersicht",
        id: "subMenuItemMinLoanViolations",
        requiresLogin: true,
      },
      {
        displayName: "Assets Validieren",
        title: "Assets Validieren",
        href: "/assetsValidieren",
        id: "subMenuItemValidateAssets",
        requiresLogin: true,
      },
    ],
    requiresLogin: true,
  },
  {
    displayName: "STAMMDATENVERWALTUNG",
    title: "STAMMDATENVERWALTUNG",
    href: null,
    id: "mainMenuItemStammdatenVerwaltung",
    subMenu: [
      {
        displayName: "Stichwortverwaltung",
        title: "Stichwortverwaltung",
        id: "subMenuItemKeywordManagement",
        href: "/keywords",
        requiresLogin: true,
      },
      {
        displayName: "Branchenverwaltung",
        title: "Branchenverwaltung",
        href: "/BranchesManagement",
        id: "subMenuItemBranchesManagement",
        requiresLogin: true,
      },
      {
        displayName: "Klauselausprägung verwalten",
        title: "Klauselausprägung verwalten",
        href: "/klauselKonfiguration",
        requiresLogin: true,
      },
      {
        displayName: "Gesetzliche Mindestlöhne verwalten",
        title: "Gesetzliche Mindestlöhne verwalten",
        href: "/mindestlohnVerwalten",
        requiresLogin: true,
      },
      //{
      //  displayName: "Feiertagskalender verwalten",
      //  title: "Feiertagskalender verwalten",
      //  href: "/resourceCalendar",
      //  requiresLogin: true,
      //},
      //{
      //  displayName: "Zuschlagsrechner Übersetzungen",
      //  title: "Zuschlagstypen verwalten",
      //  href: "/wageSupplementTypeConfigurationManagement",
      //  requiresLogin: true,
      //},
      {
        displayName: "Branchenüblicher Lohn",
        title: "Stammdaten Branchenüblicher Lohn verwalten",
        href: "/ueblicherLohnStammdaten",
        requiresLogin: true,
      },
    ],
    requiresLogin: true,
  },
  {
    displayName: "LOGS",
    title: "LOGS",
    href: null,
    id: "mainMenuItemLogs",
    subMenu: [
      {
        displayName: "Audit Log",
        title: "Audit Log",
        href: "/auditlog",
        id: "subMenuItemGavService",
        requiresLogin: true,
      },
      {
        displayName: "Admin Log",
        title: "Admin Log",
        href: "/errorlog/admin",
        id: "subMenuItemGavService",
        requiresLogin: true,
      },
      {
        displayName: "Tempdata Log",
        title: "Tempdata Log",
        href: "/errorlog/tempdataapi",
        id: "subMenuItemGavService",
        requiresLogin: true,
      },
      {
        displayName: "Seco Log",
        title: "Seco Log",
        href: "/errorlog/secoapi",
        id: "subMenuItemGavService",
        requiresLogin: true,
      },
      {
        displayName: "Gav-Service Log",
        title: "Gav-Service Log",
        href: "/errorlog/gavservice",
        id: "subMenuItemGavService",
        requiresLogin: true,
      },
    ],
    requiresLogin: true,
  },
  {
    displayName: "CRM / Benutzerverwaltung",
    title: "CRM / Benutzerverwaltung",
    href: null,
    id: "mainMenuItemUserManagement",
    subMenu: [
      {
        displayName: "Benutzerverwaltung",
        title: "Benutzerverwaltung",
        href: "/users",
        id: "subMenuItemUserManagement",
        requiresLogin: true,
      },
      {
        displayName: "Kontakte",
        title: "Kontakte",
        href: "/contacts",
        id: "subMenuItemContacts",
        requiresLogin: true,
      },
      {
        displayName: "Anrede",
        title: "Anrede",
        href: "/anrede",
        id: "subMenuItemAnrede",
        requiresLogin: true,
      },
      {
        displayName: "Organisationen",
        title: "Organisationen",
        href: "/organisation",
        id: "subMenuItemOrganisation",
        requiresLogin: true,
      },
      {
        displayName: "Verträge und Zuständigkeiten",
        title: "Verträge und Zuständigkeiten",
        href: "/contractsAndResponsibilities",
        id: "subMenuItemContractsAndResponsibilities",
        requiresLogin: true,
      },
    ],
    requiresLogin: true,
  },
  {
    displayName: "News Feed",
    title: "News Feed",
    href: "/rssFeedManagement",
    id: "mainMenuItemNewsFeed",
    subMenu: [],
    requiresLogin: true,
  },
  {
    displayName: "CMS",
    title: "CMS",
    href: null,
    id: "mainMenuItemCms",
    subMenu: [
      {
        displayName: "GAV Service",
        title: "GAV Service",
        href: "gavServiceUrl",
        id: "subMenuItemGavService",
        requiresLogin: true,
      },
      {
        displayName: "Unia Service",
        title: "Unia Service",
        href: "uniaServiceUrl",
        id: "subMenuItemUniaService",
        requiresLogin: true,
      },
    ],
    requiresLogin: true,
  },
  {
    displayName: "Merkliste",
    title: "Merkliste",
    href: null,
    id: "mainMenuItemBookmarks",
    isMerkliste: true,
    subMenu: [],
    requiresLogin: true,
  },
  {
    displayName: "Auswertung",
    title: "Auswertung",
    href: "/auswertung",
    id: "mainMenuItemAuswertung",
    subMenu: [],
    requiresLogin: true,
  },
  {
    displayName: "Logout",
    title: "Logout",
    href: "#",
    id: "mainMenuItemLogout",
    isLogin: true,
    subMenu: [],
  },
];
